import { Company } from '../../../../types';
import ApiClient from '../../../../shared/ApiCliente';

export const companyService = {
  getAllCompanies: async (): Promise<Company[]> => {
    try {
      const response = await ApiClient.get<Company[]>('/empresas');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar todas as empresas:', error);
      return [];
    }
  },
};


